import React from 'react';
import {
  Box,
  Card,
  TextField,
  InputAdornment,
  CardContent,
  Typography,
  SvgIcon,
  Button
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Search as SearchIcon } from 'react-feather';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

const EventDetailsToolbar = ({ style, onSearch = () => {} }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();

  return (
    <Box style={style}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box sx={{ mx: 1 }}>
          <Typography
            color="textPrimary"
            variant="h3"
          >
            {`Event ${state.title}`}
          </Typography>
          <Typography
            color="textPrimary"
            variant="h6"
          >
            20/12/2021
          </Typography>
        </Box>
        <Button
          onClick={() => {
            navigate(`/app/addLead/${id}`, { replace: false, state });
          }}
          sx={{ mx: 1 }}
          color="primary"
          variant="contained"
        >
          Add Lead
        </Button>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <CardContent>
            <Box sx={{ maxWidth: 500 }}>
              <TextField
                onChange={(e) => onSearch(e.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon
                        fontSize="small"
                        color="action"
                      >
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )
                }}
                placeholder="Search customer"
                variant="outlined"
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

EventDetailsToolbar.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  onSearch: PropTypes.func
};

EventDetailsToolbar.defaultProps = {
  style: [],
};
export default EventDetailsToolbar;
